import * as UT from "@app/services/UserTiming.service";
import { Def } from "@card/common/definitions";
// @ts-ignore
import { isCardError } from "@card/common/is-card-error";
import { PaymentMethod } from "@app/models/PaymentMethod";
import { PaymentEntityType } from "@app/models/PaymentEntityType";
import { UserTimingService } from "@app/services/UserTiming.service";
import { catchError, finalize, map, switchMap, take, takeUntil } from "rxjs/operators";
import { AppDate } from "@app/util/app-date";
import { Homeowner } from "@app/models/Homeowner";
import { Property } from "@app/models/Property";
import { PaymentRequest } from "@app/models/PaymentRequest";
import { CountryAndStateApi } from "@app/services/apiServices/CountryAndStateApi";

import { moneyAdd, moneyNumber } from "@app/util/money-number";
import { Payment } from "@app/models/Payment";
import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { HeaderService } from "@app/components/header/header.service";
import { PaymentMethodApi } from "@app/services/apiServices/PaymentMethodApi";
import { MatDialog } from "@angular/material/dialog";
import { PaymentApi } from "@app/services/apiServices/PaymentApi";
import { FTNIApi } from "@app/services/apiServices/FTNIApi";
import { SpinnerService } from "@app/services/spinner.service";
import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { PaymentDateService } from "@app/services/PaymentDate.service";
import { ErrorHandlerService } from "@app/services/ErrorHandler.service";
import { AppDataService } from "@app/services/appData.service";
import {
    AddressFormComponentProps,
    AddressFormData,
    CardAddressComponent
} from "@app/components/card/card-address.component";
import { PaymentDeclinedDialog } from "@app/components/sharedDialogs/payment-declined.dialog";
import { CardDetailAddComponent } from "@app/components/card/card-detail-add.component";
import { CardDetailEditComponent, CardDetailEditProps } from "@app/components/card/card-detail-edit.component";
import { ActivatedRoute, Router } from "@angular/router";
import { PaymentTimingType } from '@app/services/shared/PaymentTimingType.enum';
import { ScheduleFrequencyType } from "@app/services/shared/ScheduleFrequencyType.enum";
import { PaymentCorrelationRequest } from "@app/models/PaymentCorrelation";
import { PaymentCorrelationService } from "@app/services/payment-correlation.service";
import { from, of, Subject } from "rxjs";

@Component({
    selector: 'app-guest-payment-card',
    template: require('./guestPaymentCard.html')
})
export class GuestPaymentCardComponent implements OnInit, OnDestroy {
    @ViewChild(CardDetailAddComponent) cardDetailAddComponent: CardDetailAddComponent;
    @ViewChild(CardDetailEditComponent) cardDetailEditComponent: CardDetailEditComponent;
    @ViewChild(CardAddressComponent) cardAddressComponent: CardAddressComponent;

    @ViewChild('GuestPaymentCard', { static: true }) private guestPaymentCardForm;
    paymentDate: AppDate;
    paymentDateDisplay: string;

    /** Used by template, populated from GuestPaymentStore */
    homeowner: Homeowner;
    /** Used by template, populated from GuestPaymentStore */
    property: Property;

    paymentRequest: PaymentRequest;
    // from GuestPaymentStore

    totalPaymentAmount: number;

    paymentAmtErrMsg: string;
    tcCheckbox: boolean;
    paymentDateErrorMsg: string;
    // validPaymentDate: boolean;
    hideResetAmountLink: boolean = true;

    /** config for date-picker, must be set in constructor! */
    // datePickerConfig: DATE_PICKER_CONFIG = null;

    paymentEntityType: PaymentEntityType;
    maxPrincipalAmount: number;

    /** do not set directly! */
    convenienceFee: number | string;

    /** do not set directly! */
    paymentAmount: number | string;
    cardFormValid: boolean = false;
    addressFormValid: boolean = false;
    UNSELECTED = -1;
    prefillAddressForm = this.UNSELECTED;
    cardProps = {};
    cardEditProps: CardDetailEditProps = {
        addressDisabled: false,
        cardDisabled: false,
        existingCard: undefined,
        makeDefault: false,
        nickName: ""
    };
    editCard: boolean = false;

    addressProps: AddressFormComponentProps = {
        disablePOBoxes: false
    }
    private destroy$ = new Subject<void>();

    constructor(
        @Inject(AppDataService) private appDataService: AppDataService,
        @Inject(HeaderService) private headerService: HeaderService,
        // close header on construction

        @Inject(PaymentMethodApi) private paymentMethodApi: PaymentMethodApi,
        // for getting bank name of routing number

        @Inject(MatDialog) private dialog: MatDialog,
        // open terms and helper info
        @Inject(CountryAndStateApi) private countryAndStateApi: CountryAndStateApi,
        // populate the countries for DigitalPayment
        @Inject(PaymentApi) private paymentApi: PaymentApi,
        // get convenience fee

        @Inject(FTNIApi) private ftniApi: FTNIApi,
        // for getting payment token from values

        @Inject(PaymentCorrelationService) private paymentCorrelationService: PaymentCorrelationService,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(GuestPaymentStore) private guestPaymentStore: GuestPaymentStore,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
        @Inject(PaymentDateService) private pmtDateService: PaymentDateService,
        @Inject(UserTimingService) private userTiming: UserTimingService,
        @Inject(ErrorHandlerService) private errorHandlerService: ErrorHandlerService,
        @Inject(Router) private router: Router,
        @Inject(ActivatedRoute) private activatedRoute: ActivatedRoute,
    ) {
        this.paymentEntityType = this.activatedRoute.snapshot.data.paymentEntityType;
    }

    ngOnInit() {
        this.spinnerService.showSpinner();
        this.headerService.setDisplayRightContent(false);

        this.setDefaultValues()
        try {
            this.pmtDateService.delayTodaysPayment = this.guestPaymentStore.getDelayTodaysPayment();
        } catch (_invalidDateOrPropertyAccessError) { }
        //Get the valid payment date
        this.loadValidPaymentDate();

        if (!this.paymentRequest) {
            this.paymentRequest = {
                acceptedTerms: true,
                acceptedTermsDate: ''
            }
        }

        this.maxPrincipalAmount = this.appDataService.appSettings.paymentLimits.maxPrincipalAmount ?? null
    }

    private loadValidPaymentDate() {
        this.paymentApi.getPaymentDate(this.pmtDateService.delayTodaysPayment, true).pipe(
            take(1),
            takeUntil(this.destroy$),
            finalize(() => this.spinnerService.closeSpinner())
        ).subscribe({
            next: (response) => {
                this.paymentDate = AppDate.fromString(response.paymentDate, 'yyyy-MM-dd');
                this.paymentDateDisplay = this.paymentDate.format('MM/dd/yyyy');
            },
            error: (err) => {
                console.error("Error loading valid payment date:", err);
                const errMsg = err?.error?.message || undefined;
                this.errorHandlerService.handleNetworkError(err, true, errMsg);
            }
        })
    }

    private setConvenienceFee(value: number) {
        value = Number(value)
        if (isNaN(value) || value < 0) this.convenienceFee = ''
        else this.convenienceFee = value.toFixed(2)
        this.updateTotalAmount()
    }

    private setPaymentAmount(value: number, validate: 'validate' | 'no validate' = 'validate') {
        value = Number(value)

        if (isNaN(value) || value <= 0) this.paymentAmount = ''
        else this.paymentAmount = value.toFixed(2)

        this.paymentAmtErrMsg = null
        if (validate === 'validate') {
            this.validatePaymentAmount()
        }

        // Update dependent parts
        this.updateResetOriginalAmountLink()
        this.updateConvenienceFee()
        this.updateTotalAmount()
    }

    getPaymentMethod(paymentToken: string, payerId: number): PaymentMethod {
        if (typeof paymentToken !== 'string' || !paymentToken) throw new Error('Expected paymentToken to be string');
        if (typeof payerId !== 'number' || isNaN(payerId)) throw new Error('Expected payerId to be number');

        return {
            token: paymentToken,
            payerId: payerId,
            // maskedId: this.checkingAccount.accountNumber.length <= 4 ? this.checkingAccount.accountNumber.slice(-2) : this.checkingAccount.accountNumber.slice(-4)
        }
    }

    onAddressValid(isValid: boolean) {
        this.addressFormValid = isValid;
    }

    onCardValid(isValid: boolean) {
        this.cardFormValid = isValid;
    }
    onSubmit() {
        if (!this.cardFormValid) {
            alert("We were unable to move forward due to errors in the form.\n")
            return
        }

        this.spinnerService.showSpinner()

        // Create User Timer for analytics
        const submitTimer = this.userTiming.startTimer(UT.CATEGORIES.FTNI, 'Create Card Payment Token', 'Verifying Card Payment Details');

        const homeowner = this.guestPaymentStore.getHomeowner()
        const payerId = homeowner.id

        let cardAction = this.editCard ?
            this.cardDetailEditComponent.updateCard(payerId, this.cardEditProps.existingCard.paymentToken,
                this.cardEditProps.existingCard.maskedCardNumber,
                this.cardEditProps.existingCard.cardBrand,
                this.formatAddressForUpdate(this.cardAddressComponent.getFormData())) :
            this.cardDetailAddComponent.createCard(payerId, this.cardAddressComponent.getFormData(), this.cardDetailAddComponent.getFormData());

        from(cardAction)
            .pipe(
                take(1),
                switchMap(cardUpdate => {
                    const error = cardUpdate as Def.CardError;
                    const hasError = error.ftni !== undefined;
                    if (hasError && error.ftni.FTNIApprovalCode) {
                        const dialogRef = this.dialog.open(PaymentDeclinedDialog, {
                            data: { errorMessage: "We are unable to add this card to your wallet because it was declined. Please contact the bank that issued your card for more information." },
                        });
                        return dialogRef.afterClosed().pipe(
                            take(1),
                            map(() => null),
                        );
                    }
                    submitTimer.stop("Card Token Creation Succeeded");
                    this.spinnerService.closeSpinner();

                    // add whatever is needed to payment method in addition to what we get from FTNI
                    // set payment Method object

                    // protect the security code for PCI comnpliance
                    delete cardUpdate["securityCode"];

                    const pmtReq = this.createPaymentRequest(cardUpdate.paymentToken, payerId);

                    pmtReq.paymentMethod.maskedId = cardUpdate.maskedCardNumber.slice(-4);
                    // set masked id for display purposes in confirmation page
                    pmtReq.paymentMethod.cardBrand = cardUpdate.cardBrand;
                    // set card brand as it is required for processing

                    this.guestPaymentStore.setCardUpdate(cardUpdate);
                    this.guestPaymentStore.setPayment(this.getPayment());
                    this.guestPaymentStore.setPaymentRequest(pmtReq);

                    this.guestPaymentStore.clearCorrelationId();

                    const correlationRequest: PaymentCorrelationRequest = {
                        payerId: this.homeowner.id,
                        entityId: pmtReq.property.id.toString(),
                    };

                    return this.paymentCorrelationService
                        .createCorrelationId(true, correlationRequest)
                        .pipe(take(1));
                }),
                catchError(error => {
                    let errMsg: string = 'System error occurred. Please try again in a few hours.';
                    let err = {
                        status: 400
                    }
                    this.errorHandlerService.handleNetworkError(
                        err,
                        true,
                        errMsg
                    )
                        .pipe(take(1))
                        .subscribe();

                    return of(null);
                }),
                finalize(() => this.spinnerService.closeSpinner())
            )
            .subscribe((correlationId: string | null) => {
                if (!correlationId) {
                    return;
                }

                this.guestPaymentStore.setCorrelationId(correlationId);

                const nextPage =
                    this.paymentEntityType === PaymentEntityType.AMENITY
                        ? 'amenities/guestPaymentConfirmation'
                        :'guestPaymentConfirmation';

                this.router.navigateByUrl(nextPage);
            });
    }

    private validatePaymentAmount() {
        const paymentAmountNum: number = Number(this.paymentAmount);
        this.updateResetOriginalAmountLink();

        if (this.paymentAmount == null || this.paymentAmount === '' || paymentAmountNum === 0) {
            this.paymentAmtErrMsg = "Payment amount is required.";

        } else if (isNaN(paymentAmountNum)) {
            this.paymentAmtErrMsg = "Payment amount must be a number.";

        } else if (this.maxPrincipalAmount && paymentAmountNum > this.maxPrincipalAmount) {
            this.paymentAmtErrMsg = "Payment amount cannot exceed $" + this.maxPrincipalAmount;

        } else {
            this.paymentAmtErrMsg = null;
        }
    }

    /**
     * Check validity of everything
     */
    valid(): boolean {
        return (
            this.cardFormValid
                && this.addressFormValid
                && !this.convenienceFeeIsPending
                && Number(this.paymentAmount)
                && this.paymentDate
                && this.tcCheckbox
                && !this.paymentAmtErrMsg
                && !this.paymentDateErrorMsg
        )
    }

    invalid(): boolean {
        return !this.valid()
    }

    getOriginalAmount(): number {
        // Baldwin: Treat redirect amount as an amount which is just filled in really fast (MMDP-2248)
        //          If there is no amount due from the billing summary, then there should not be any
        //          "Reset Original Amount" link
        return this.guestPaymentStore.getPropertyAmountDue() || undefined
    }

    updateResetOriginalAmountLink() {
        const paymentAmountNum = Number(this.paymentAmount)

        // check to see if the link needs to be shown
        const originalAmount = this.getOriginalAmount();
        if (originalAmount == null) {
            // if there is no original amount, hide the link
            this.hideResetAmountLink = true;
            return
        }

        const showResetLink = paymentAmountNum !== originalAmount
        this.hideResetAmountLink = !showResetLink;
    }

    updateTotalAmount() {
        this.totalPaymentAmount = moneyAdd(Number(this.convenienceFee) || 0, this.paymentAmount);
    }

    /** Use to disable next button */
    private convenienceFeeIsPending: boolean = false
    private updateConvenienceFeeTimer: any;

    updateConvenienceFee(delay: number = 400) {
        // use cancel to debounce
        clearTimeout(this.updateConvenienceFeeTimer);
        this.convenienceFeeIsPending = true
        // disables next button

        // manually invoke a delay here so the convenience fee formula is not so obvious
        this.updateConvenienceFeeTimer = setTimeout(() => {
            // falsey if paymentAmount is 0 or NaN
            if (this.property && Number(this.paymentAmount)) {
                this.paymentApi.convenienceFeePropertyIdAmountGet(true,
                    this.property.address.state, this.property.address.state,
                    moneyNumber(this.paymentAmount), this.property.hoa.pmc.couponId,
                    this.property.hoa.couponId, 'CARD', PaymentTimingType.ONE_TIME, ScheduleFrequencyType.ONE_TIME).pipe(take(1)).subscribe({
                    next: data => {
                        this.setConvenienceFee(data.convenienceFee);
                        this.updateTotalAmount();

                        this.convenienceFeeIsPending = false
                        // needed so the next button is enabled

                    },
                    error: err => {
                        this.networkErrorService.handleNetworkError(err, false).pipe(take(1)).subscribe((resp) => {
                            if (resp === true) {
                                this.updateConvenienceFee();
                            }
                        });
                    } });
            }
        }, delay);
    }

    onPmtAmtInputChange = () => {
        this.updateConvenienceFee(1000)
        this.validatePaymentAmount()
    }

    onPmtAmtInputFocus() {
        this.clearPaymentAmtIf0()
    }

    onPmtAmtInputBlur() {
        this.setPaymentAmount(Number(this.paymentAmount))
        this.clearPaymentAmtIf0()
    }

    clearPaymentAmtIf0() {
        if (!Number(this.paymentAmount)) {
            this.setPaymentAmount(null, 'validate');
            this.setConvenienceFee(0);
        }
    }

    clearPaymentAmount() {
        this.setPaymentAmount(null, 'validate');
        this.setConvenienceFee(0);
    }

    resetPaymentAmount() {
        this.setPaymentAmount(this.getOriginalAmount(), 'no validate')
    }

    setDefaultValues() {
        /** Set the homeowner and property for template */
        this.homeowner = this.guestPaymentStore.getHomeowner();
        this.property = this.guestPaymentStore.getProperty();
        this.paymentRequest = this.guestPaymentStore.getPaymentRequest();
        let existCard = this.guestPaymentStore.getCardUpdate();
        if (this.paymentRequest && existCard) {
            this.editCard = true;
            this.cardEditProps.existingCard = existCard;
            this.cardEditProps.disableExpirationDate = true;
        }

        if (this.homeowner == null || this.property == null) {
            !window.__karma__ && console.error('Either homeowner or property was undefined. Redirecting to guest contact form.', { homeowner: this.homeowner, property: this.property })
            // redirect to page for filling out info
            this.router.navigateByUrl('/guestpayment');
            return
        }

        // reset the payment amount first, then next check if value already made
        this.resetPaymentAmount()

        const redirectAmount = this.guestPaymentStore.getRedirectAmount()
        if (redirectAmount != null) {
            // MMDP-2248: Redirect amount should behave just as though the user quickly typed in their information
            this.setPaymentAmount(redirectAmount, 'validate')
        }

        // Check if a payment amount has already been entered first to handle when a user goes back to edit payment
        const paymentFromSession = this.guestPaymentStore.getPayment();
        if (paymentFromSession) {
            if (paymentFromSession.hasOwnProperty('principalAmount')) {
                this.setPaymentAmount(paymentFromSession.principalAmount);
            }

            if (paymentFromSession.hasOwnProperty('totalPaymentAmount')) {
                this.totalPaymentAmount = moneyNumber(paymentFromSession.totalPaymentAmount);
            }

            if (paymentFromSession.hasOwnProperty('feeAmount')) {
                this.setConvenienceFee(paymentFromSession.feeAmount);
                this.updateConvenienceFee()
            }
        }

        // update convenience fee on load
        this.updateConvenienceFee();
    }

    getPayment(): Payment {
        return {
            feeAmount: moneyNumber(this.convenienceFee),
            totalPaymentAmount: moneyNumber(this.totalPaymentAmount),
            principalAmount: moneyNumber(this.paymentAmount),
        }
    }

    /**
     * Set {@link GuestPaymentCheckComponent::paymentRequest} based on form values and parameters
     * @param paymentToken FTNI payment token used to identify payment method registered with FTNI
     * @param payerId The homeownerId paying the due
     */
    createPaymentRequest(paymentToken: number, payerId: number): PaymentRequest {
        const pmtDateObject = this.pmtDateService.dateObjectFromAppDate(this.paymentDate)
        const today = AppDate.now()
        const nextPmtDate = this.pmtDateService.getNextValidDate(today, this.appDataService.appConfig.CUTOFF_HOUR, this.appDataService.appConfig.CUTOFF_MINUTE, today.addDays(365))

        return {
            payment: this.getPayment(),

            // these dates either represent the "selected date" or the "guaranteed process date," but since the logic for dates is done here,
            // but there are both, because of backwards compatibility
            // on the front end, it is difficult to pin down exactly the difference.
            paymentDate: pmtDateObject,

            // effective date represents the date it will be processed.
            // MMDP-1890
            effectiveDate: pmtDateObject,

            // if this payment date is after the date which would typically process
            futureDatedPayment: this.paymentDate.isAfter(nextPmtDate),

            paymentMethod: this.getPaymentMethod(String(paymentToken), Number(payerId)),
            paymentSiteId: this.property.hoa.paymentSiteId,
            property: this.property,
            acceptedTerms: this.tcCheckbox,
            acceptedTermsDate: today.format("yyyy-MM-dd"),
            paymentEntityType: this.paymentEntityType === PaymentEntityType.AMENITY ? PaymentEntityType.AMENITY : PaymentEntityType.PROPERTY,
            details: this.paymentRequest ? this.paymentRequest.details : null
        }
    }

    onClickBack() {
        this.router.navigateByUrl(this.paymentEntityType === PaymentEntityType.AMENITY ? '/amenities/select' : '/guestpayment');
    }

    toggleEditCard() {
        this.editCard = false;
    }

    formatAddressForUpdate(addressFormData: AddressFormData): Def.BillingAddress {
        return {
            line1: addressFormData.address1,
            line2: addressFormData.address2,
            unit: addressFormData.unit,
            city: addressFormData.city,
            state: addressFormData.state,
            zipcode: addressFormData.zip,
            country: addressFormData.country,
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
